import numeral from "numeral";
import { useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useDebtStore } from "../../../_store/debtplanStore";
import { useEducationStore } from "../../../_store/educationStore";
import { useFuturePlanStore } from "../../../_store/futurePlanStore";
import { useRetireStore } from "../../../_store/retireStore";
import { useUserStore } from "../../../_store/userStore";
import {
  DonutChartDebt,
  DonutChartEmpty,
} from "../../../components/chart/DonutChartMain";
import { cn } from "../../../utils/useFunctions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_12,
  STYLE_PDF_TEXT_MEDIUM_13,
  STYLE_PDF_TEXT_MEDIUM_BLUE_13,
} from "../styles/pdf.style";

function PdfPageOVDebtOne({ page }) {
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const educationData = useEducationStore((state) => state.educationData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const debtData = useDebtStore((state) => state.debtData);
  const userData = useUserStore((state) => state.userData);
  const retireData = useRetireStore((state) => state.retireData);

  const createSumObject = (sum_per_month, sum_per_year, sum_percent) => ({
    sum_per_month: sum_per_month || 0,
    sum_per_year: sum_per_year || 0,
    sum_percent: sum_percent || 0,
  });

  const sumLong = useMemo(() => {
    return createSumObject(
      balanceData?.sum_debt_long_permonth,
      balanceData?.sum_debt_long,
      (balanceData?.sum_debt_long / balanceData?.debt_propotion) * 100
    );
  }, [balanceData]);

  const sumShort = useMemo(() => {
    return createSumObject(
      balanceData?.sum_debt_short_permonth,
      balanceData?.sum_debt_short,
      (balanceData?.sum_debt_short / balanceData?.debt_propotion) * 100
    );
  }, [balanceData]);

  const sumTotal = useMemo(
    () => sumLong.sum_per_year + sumShort.sum_per_year,
    [sumLong, sumShort]
  );

  const items = useMemo(() => {
    return [
      {
        title: "หนี้สินระยะสั้น",
        icon: "credit_card.svg",
        ...sumShort,
      },
      {
        title: "หนี้สินระยะยาว",
        icon: "home_loan.svg",
        ...sumLong,
      },
    ];
  }, [sumTotal]);

  return (
    <div
      style={{
        backgroundImage: `url(/images/bg_pdf.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom right",
      }}
      className={cn(STYLE_PAGE)}
    >
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="สัดส่วนหนี้สินของคุณ" icon="/images/cash.svg" />
      <PdfCard>
        <PdfCardWhite>
          {/* <div className={cn("text-center", STYLE_PDF_TEXT_MEDIUM_12)}>
            คุณมีภาระหนี้สินเฉลี่ยต่อเดือน
          </div> */}

          <div className="">
            {balanceData?.debt_propotion <= 0 ||
            balanceData?.debt_propotion === undefined ? (
              <DonutChartEmpty
                text={`รายรับ`}
                labelLists={[
                  { value: balanceData?.sum_debt_short, color: "#E71E26" },
                  {
                    value: balanceData?.sum_debt_long,
                    color: "#FF7A00",
                  },
                ]}
              />
            ) : (
              <DonutChartDebt
                text={`หนี้สิน`}
                value={numeral(balanceData?.debt_propotion).format("0,0")}
                // defalut={getDebtBalance > 0 ? 0 : 100}
                data1={balanceData?.sum_debt_short}
                data2={balanceData?.sum_debt_long}
                labelLists={[
                  {
                    name: "หนี้สินระยะสั้น",
                    value: balanceData?.sum_debt_short,
                    color: "#E71E26",
                  },
                  {
                    name: "หนี้สินระยะยาว",
                    value: balanceData?.sum_debt_long,
                    color: "#FF7A00",
                  },
                ]}
                classNameGray={"bg-white"}
                isRemoveGray
                isRemoveLegend
                classNameDonut={"w-[200px] top-4 mb-2"}
                classNameText={cn("text-lg")}
                classNameValue={cn("text-lg")}
              />
            )}
          </div>

          <div
            className={cn(
              "grid grid-cols-3 px-3 items-center",
              STYLE_PDF_TEXT_MEDIUM_12
            )}
          >
            <div>หนี้สิน</div>
            {/* <div className={cn("text-right")}>ต่อเดือน (บาท)</div> */}
            <div className={cn("text-right")}>จำนวนเงินค้างชำระ (บาท)</div>
            <div className={cn("text-right")}>%</div>
          </div>
          <PdfLine className={"mb-1 mt-1"} />

          <div className="flex flex-col space-y-2">
            {items?.map((item, index) => {
              return (
                <div
                  key={index}
                  className={cn(
                    "grid grid-cols-3 px-3 items-center",
                    STYLE_PDF_TEXT_MEDIUM_12
                  )}
                >
                  <div className="flex space-x-2">
                    <div>
                      <img
                        className={cn(item?.classNameIcon)}
                        src={`/images/${item.icon}`}
                      />
                    </div>
                    <div>{item.title}</div>
                  </div>
                  {/* <div className="text-right">
                    {numeral(item.sum_per_month).format("0,0")}
                  </div> */}
                  <div className="text-right">
                    {numeral(item.sum_per_year).format("0,0")}
                  </div>
                  <div className="text-right">
                    {numeral(item.sum_percent).format("0.00")}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex justify-center items-center space-x-1 mt-2">
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_13)}>
              รวมหนี้สินทั้งหมด
            </div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_13)}>
              {numeral(sumTotal).format("0,0")}
            </div>
            <div className={cn(STYLE_PDF_TEXT_MEDIUM_BLUE_13)}>บาท</div>
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageOVDebtOne;
